import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'
import {UploadAttachmentUserRequest} from '../Requests/UploadAttachmentUserRequest.js'

export class UploadAttachmentUserUseCase extends UseCase {
  #repository
  #config

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new UploadAttachmentUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  @tracer({metric: 'UploadAttachmentUserUseCase#execute'})
  @AsyncInlineError()
  async execute({channelId, file}) {
    const [error, fileAttachmentEntity] = await this.#repository.uploadAttachment({
      uploadAttachmentUserRequest: UploadAttachmentUserRequest.create({channelId, file})
    })

    if (error) return Promise.reject(error)

    return fileAttachmentEntity.toJSON()
  }
}

export const factory = UploadAttachmentUserUseCase.create
